/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_TitleInputs */

const en_faq_cta_title = /** @type {(inputs: Faq_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real conversation helps.`)
};

const lv_faq_cta_title = /** @type {(inputs: Faq_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Īsta saruna palīdz.`)
};

/**
* | output |
* | --- |
* | "A real conversation helps." |
*
* @param {Faq_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_cta_title = /** @type {((inputs?: Faq_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_cta_title(inputs)
	return en_faq_cta_title(inputs)
});